import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
import mixin from './components/mixin.js';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import VueSignaturePad from 'vue-signature-pad';
import UploadImage from 'vue-upload-image';
 
Vue.config.productionTip = false

Vue.use(vuetify);
Vue.use(VueAxios, axios);
Vue.use(VueSignaturePad);

//Vue.prototype.ImagesBaseUrl = 'http://ns3147680.ip-51-91-7.eu/Images/';

//Vue.prototype.ApiBaseUrlNETCore = 'http://localhost:5000/';
//Vue.prototype.ApiBaseUrlNETCore = 'http://ns3147680:5000/';
//Vue.prototype.ApiBaseUrlNETCore = 'http://ns3147680.ip-51-91-7.eu:5000/';
//Vue.prototype.ApiBaseUrlNETCore = 'http://7b96efcd-0527-4b1a-a903-3b6ca5e22445.clouding.host/api/';
//Vue.prototype.ApiBaseUrlNETCoreWatergy = 'http://7b96efcd-0527-4b1a-a903-3b6ca5e22445.clouding.host/apiw/';
Vue.prototype.ApiBaseUrlNETCore = process.env.NODE_ENV == 'production' ? '/api/' : 'http://localhost:5000/' ;
Vue.prototype.ApiBaseUrlNETCoreWatergy = '/apiw/';

Vue.mixin(mixin);

Vue.component('upload-image', UploadImage);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
